import { connect } from 'react-redux';

import AttachmentModal from './';

const mapStateToProps = (state, ownProps) => {
  const attachmentId = ownProps.match.params.attachmentId;
  return {
    attachmentId,
  }
};

export default connect(mapStateToProps, null)(AttachmentModal);
